import { For, JSXElement, Match, Show, Switch, Setter } from 'solid-js'
import { useSelector } from '../../store'
import { useIcon } from '../icon/useIcon'
import { useI18n } from '../../i18n'
import { useConfig } from '../config/useConfig'
import webStyle from './ToastWeb.module.css'
import stvStyle from './ToastSTV.module.css'
import { isWeb } from '../../utils'

export enum ToastType {
    PLAIN = 'toast-plain',
    ERROR = 'toast-error',
    WARNING = 'toast-warning',
    SUCCESS = 'toast-success',
    INFO = 'toast-info',
    REMINDER = 'toast-reminder',
}

export enum ToastPosition {
    TOP_LEFT = 'top-left',
    TOP_RIGHT = 'top-right',
    BOTTOM_LEFT = 'bottom-left',
    BOTTOM_RIGHT = 'bottom-right',
    TOP_CENTER = 'top-center',
}

export interface ToastProps {
    title: string
    description: string
    subDescription?: string
    type: ToastType | undefined
    actions?: JSXElement[]
    index?: number
    onClose?: (id: any) => void
    className?: string
    id?: number
    life?: number
    position?: ToastPosition
    sticky?: boolean
    link?: string
    programId?: string
    channelId?: string
    eventId?: string
    pendingTime?: string
    handlePlay?: any
    onCancelReminder?: any
    autoClosed?: boolean
    onReminderHandleFocus?: any
    deleteReminder?: any
    updateLocalShowedReminder?: any
    iconType?:any
    setAutoClosed?: Setter<boolean>
    packages?: any
}


export const Toast = (props: ToastProps) => {
    
    const icons = useIcon()
    const { getI18n } = useI18n()
    const { getConfig } = useConfig()
   
    const locale = useSelector((state: any) => state?.language?.locale)

    const style = isWeb ? webStyle : stvStyle

    const showNoQuotaToast = useSelector((s: any) => s.recordings?.showNoQuotaToast) 

    const handleIndexValue: any = () => {
        return `${(props?.index || 0) * 80 + 15}px`
    }

    const CloseIcon = icons.get('CloseCross')
    const SuccessIcon = icons.get('Success')
    const WarningIcon = icons.get('Warning')
    const InfoIcon = icons.get('Information')
    const ErrorIcon = icons.get('Error')
    const StarhubQrcode = icons.get('starhubQrcode')

    const getStyle = (): string => {
        switch (props?.position) {
            case ToastPosition.TOP_CENTER:
            case ToastPosition.TOP_RIGHT:
            case ToastPosition.TOP_LEFT: {
                return 'top'
            }
            case ToastPosition.BOTTOM_RIGHT:
            case ToastPosition.BOTTOM_LEFT: {
                return 'bottom'
            }
            default:
                return 'bottom'
        }
    }

    const getPosition = () => {
        switch(props.position) {
            case ToastPosition.TOP_CENTER:
            return style.topCenter
            case ToastPosition.BOTTOM_LEFT:
                return style.bottomLeft
            case ToastPosition.TOP_LEFT:
                return style.topLeft
            case ToastPosition.BOTTOM_RIGHT:
                return style.bottomRight
            case ToastPosition.TOP_RIGHT:
                return style.topRight
            default:
                return style.bottomLeft
        }
    }

    return (
        <div>
            <Show when={props?.type !== ToastType.REMINDER}>
            <Switch>
                    <Match when={props?.description === 'noRecordingQuota' && showNoQuotaToast()}>
                        <div
                            class={`${style.toastWrapper} ${props?.className} ${props?.type} ${getPosition()} ${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`}
                            style={{
                                [getStyle()]: handleIndexValue(),
                                direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`,
                            }}
                        >
                            <div class={style.toastDetailsWrapperWithImage}>
                                <div class={style.toastDescription}>
                                    {getI18n()?.formatMessage({id: 'TOAST_QRCODE_DESCRIPTION'})}
                                </div>
                                <div class={style.toastImage}>
                                    <img class={style.QR} src={StarhubQrcode} />
                                </div>
                                <div class={`${style.toastDescription} ${style.toastLink}`}>
                                    {getI18n()?.formatMessage({id: 'OR_VISIT'})}{' '}
                                    <a target="blank" href={getConfig()?.toastQRCodeLink}>
                                        {getConfig()?.toastQRCodeLink}
                                    </a>
                                </div>
                                <div class={style.toastDescription}>
                                    {getI18n()?.formatMessage({id: 'TOAST_QRCODE_SUB_DESCRIPTION'})}
                                </div>
                            </div>
                            <div class={style.toastActions}>
                                <For each={props?.actions}>
                                    {action => {
                                        return action
                                    }}
                                </For>
                                <Show when={!props?.actions}>
                                    <div
                                        class={style.toastCloseIconWrapper}
                                        id="btnCloseToast"
                                        onClick={() => props?.onClose?.(props.id)}
                                    >
                                        <CloseIcon class={style.webstvIconNew} />
                                    </div>
                                </Show>
                            </div>
                        </div>
                    </Match>
                    <Match when={props?.subDescription !== 'noRecordingQuota'}>
                        <div
                            class={`${style.toastWrapper} ${props?.className} ${getPosition()} ${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`}
                            style={{
                                [getStyle()]: handleIndexValue(),
                                direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`,
                            }}
                        >
                            <div class={style.toastIconDetailsWrapper}>
                                <div class={style.toastIconWrapper}>
                                    <Switch fallback={<SuccessIcon class={style.toastIconSuccess} />}>
                                        <Match when={props?.type === ToastType.INFO}>
                                            <InfoIcon class={style.toastIconInfo} />
                                        </Match>
                                        <Match when={props?.type === ToastType.SUCCESS}>
                                            <SuccessIcon class={style.toastIconSuccess} />
                                        </Match>
                                        <Match when={props?.type === ToastType.WARNING}>
                                            <WarningIcon class={style.toastIconWarinig} />
                                        </Match>
                                        <Match when={props?.type === ToastType.ERROR}>
                                            <ErrorIcon class={style.toastIconError} />
                                        </Match>
                                    </Switch>
                                </div>
                                <div class="toast-details-wrapper">
                                    {/* <div class={style.toastTitle}>
                                        {props?.title}
                                    </div> */}
                                    {props.packages ? (
                                        <div class={style.toastDescription}>
                                            {getI18n()?.formatMessage({id: 'SUBSCRIPTION_PACKAGE_ERROR'})}{' '}
                                            {props.packages.map((i: string) => {
                                                return (
                                                    <>
                                                        <br />
                                                        {'« ' + i + ' »'}{' '}
                                                    </>
                                                )
                                            })}
                                        </div>
                                    ) : (
                                        <div class={style.toastDescription}>{props?.description}</div>
                                    )}
                                    <div class={style.toastDescription}>{props?.subDescription ?? ''}</div>
                                    <div class={style.toastDescription}>
                                        <a target="blank" href={props?.link ?? ''}>
                                            {props?.link ?? ''}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class={style.toastActions}>
                                <For each={props?.actions}>
                                    {action => {
                                        return action
                                    }}
                                </For>
                                <Show when={!props?.actions}>
                                    <div
                                        class={style.toastCloseIconWrapper}
                                        id="btnCloseToast"
                                        onClick={() => {
                                            props?.onClose?.(props.id)
                                        }}
                                    >
                                        <CloseIcon class={style.webstvIconNew} />
                                    </div>
                                </Show>
                            </div>
                        </div>
                    </Match>
                </Switch>
            </Show>
        </div>
    )
}
